import constants from "constants/constants";
import { roundOff } from "utils/Utils";
import { is_empty } from "utils/validations";
import {
  EXLY_DASHBOARD__SET_LOADER,
  EXLY_DASHBOARD__SET_BANNER,
  EXLY_DASHBOARD__SET_BANNER_TOAST,
  EXLY_DASHBOARD__SET_LEADS,
  EXLY_DASHBOARD__SET_SUBSCRIPTION_STATS,
  EXLY_DASHBOARD__SET_SELECTED_MONTH,
  EXLY_DASHBOARD__GET_SUBSCRIPTION_STATS,
} from "./actions";
import {
  SUBSCRIPTION_STATS_CARD_CONFIG,
  SUBSCRIPTION_STATS_KEYS,
} from "../Dashboard.constants";

const initialState = {
  loader: true,
  banner: null,
  bannerToast: null,
  leads: {},
  subscription_stats: null,
  selected_filter_month: constants.current_month,
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case EXLY_DASHBOARD__SET_LOADER: {
      return { ...state, loader: payload };
    }
    case EXLY_DASHBOARD__SET_BANNER: {
      return { ...state, banner: payload };
    }
    case EXLY_DASHBOARD__SET_BANNER_TOAST: {
      return { ...state, bannerToast: payload };
    }
    case EXLY_DASHBOARD__SET_LEADS: {
      return { ...state, leads: payload };
    }
    case EXLY_DASHBOARD__GET_SUBSCRIPTION_STATS: {
      return { ...state, subscription_stats: null };
    }
    case EXLY_DASHBOARD__SET_SUBSCRIPTION_STATS: {
      let stat_data;
      if (
        payload &&
        !is_empty(payload) &&
        (payload.total_subscription_renewals > 0 ||
          payload.due_soon_count > 0 ||
          payload.over_due_count > 0 ||
          payload.total_expired_subscriptions > 0)
      ) {
        const renewalSuccessRate =
          payload.total_subscription_renewals === 0
            ? 0
            : roundOff(
                (payload.total_subscription_renewals /
                  (payload.total_subscription_renewals +
                    payload.due_soon_count +
                    payload.over_due_count)) *
                  100,
                2
              );
        const renewalSuccessRateValue = `${renewalSuccessRate}%`;

        stat_data = SUBSCRIPTION_STATS_CARD_CONFIG.map((card) => {
          const value =
            card.key === SUBSCRIPTION_STATS_KEYS.renewalSuccessRate
              ? renewalSuccessRateValue
              : payload[card.key];
          return { ...card, value };
        });
      }
      return { ...state, subscription_stats: stat_data };
    }
    case EXLY_DASHBOARD__SET_SELECTED_MONTH: {
      return { ...state, selected_filter_month: payload };
    }
    default: {
      return state;
    }
  }
};

export default reducer;
